import { t } from "i18next";

const CUSTOMER_REGEX =
  /^[a-zA-Z0-9!@#$&()\-`.+,/&+}{},:;=?@#|_ ~'<>.-^*()%"]*$/;
const ADDRESS_REGEX = /^[a-zA-Z0-9 !@#$%^&*()_+-=[\]{};':"|,.<>/?~`]+$/i;
const ONLY_TEXT = /^[a-zA-Z ]+$/i;
const CITY_REGEX = /^(?=.*[a-zA-Z])[a-zA-Z0-9 ]+$/;
const POSTAL_REGEX = /^[a-zA-Z0-9 ]+$/;
const PHONE_REGEX = /^[0-9]\d{1,30}$/;
const NAME_REGEX = /^[a-zA-Z .,'-]+$/;
const PID_REGEX = /^[0-9]\d{1,7}$/;

export const EMAIL_VALIDATION_REGEX =
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
export const getCustomerRules = () => {
  return {
    draftCustomerName: {
      required: {
        value: true,
        message: t("core:customers:validation:required", {
          name: t("core:customers:validation:draft_validation"),
        }),
      },
      maxLength: {
        value: 60,
        message: t("core:customers:validation:max_length", { max: "60" }),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
      pattern: {
        value: CUSTOMER_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:label:customer_name"),
        }),
      },
    },
    customerName: {
      required: {
        value: true,
        message: t("core:customers:validation:required", {
          name: t("core:customers:label:customer_name"),
        }),
      },
      maxLength: {
        value: 60,
        message: t("core:customers:validation:max_length", { max: "60" }),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
      pattern: {
        value: CUSTOMER_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:label:customer_name"),
        }),
      },
    },
    addressLine1: {
      required: {
        value: true,
        message: t("core:customers:validation:required", {
          name: t("core:customers:label:address_line_1"),
        }),
      },
      pattern: {
        value: ADDRESS_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:label:address_line_1"),
        }),
      },
      maxLength: {
        value: 50,
        message: t("core:customers:validation:max_length", { max: "50" }),
      },
      minLength: {
        value: 4,
        message: t("core:customers:validation:min_length", { min: "4" }),
      },
    },
    addressLine2: {
      pattern: {
        value: ADDRESS_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:label:address_line_2"),
        }),
      },
      maxLength: {
        value: 50,
        message: t("core:customers:validation:max_length", { max: "50" }),
      },
      minLength: {
        value: 4,
        message: t("core:customers:validation:min_length", { min: "4" }),
      },
    },
    country: {
      required: {
        value: true,
        message: t("core:customers:validation:required", {
          name: t("core:customers:label:country"),
        }),
      },
      pattern: {
        value: ONLY_TEXT,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:label:country"),
        }),
      },
      maxLength: {
        value: 50,
        message: t("core:customers:validation:max_length", { max: "50" }),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
    },
    city: {
      required: {
        value: true,
        message: t("core:customers:validation:required", {
          name: t("core:customers:label:city"),
        }),
      },
      pattern: {
        value: CITY_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:label:city"),
        }),
      },
      maxLength: {
        value: 50,
        message: t("core:customers:validation:max_length", { max: "50" }),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
    },
    postcode: {
      required: {
        value: true,
        message: t("core:customers:validation:required", {
          name: t("core:customers:label:post_code"),
        }),
      },
      maxLength: {
        value: 50,
        message: t("core:customers:validation:max_length", { max: "50" }),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
      pattern: {
        value: POSTAL_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:label:post_code"),
        }),
      },
    },
    area: {
      pattern: {
        value: CITY_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:area"),
        }),
      },
      maxLength: {
        value: 50,
        message: t("core:customers:validation:max_length", { max: "50" }),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
    },
    phoneNumber: {
      pattern: {
        value: PHONE_REGEX,
        message: t("core:customers:phone_number_regex"),
      },
      maxLength: {
        value: 30,
        message: t("core:customers:max_phone_number"),
      },
      minLength: {
        value: 5,
        message: t("core:customers:min_phone_number"),
      },
    },
    firstName: {
      pattern: {
        value: NAME_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:contact_first_name"),
        }),
      },
      maxLength: {
        value: 50,
        message: t("core:customers:validation:max_length", { max: "50" }),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
    },
    lastName: {
      pattern: {
        value: NAME_REGEX,
        message: t("core:customers:validation:regex_error", {
          fieldName: t("core:customers:contact_last_name"),
        }),
      },
      maxLength: {
        value: 50,
        message: t("core:customers:validation:max_length", { max: "50" }),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
    },
    email: {
      required: {
        value: true,
        message: t("core:customers:validation:required", {
          name: t("core:customers:label:contact_email"),
        }),
      },
      maxLength: {
        value: 100,
        message: t("core:customers:validation:max_length", { max: "100" }),
      },
      pattern: {
        value: EMAIL_VALIDATION_REGEX,
        message: t("core:customers:validation:email"),
      },
      minLength: {
        value: 2,
        message: t("core:customers:validation:min_length", { min: "2" }),
      },
    },
    pid: {
      required: {
        value: true,
        message: t("core:customers:validation:required", {
          name: t("core:customers:label:pid"),
        }),
      },
      maxLength: {
        value: 7,
        message: t("core:customers:validation:max_pid"),
      },
      pattern: {
        value: PID_REGEX,
        message: t("core:customers:validation:pid_regex_error"),
      },
      minLength: {
        value: 6,
        message: t("core:customers:validation:min_pid"),
      },
    },
  };
};
